import React from 'react';

import { Grid } from '@material-ui/core';

import { StillInRaceUserInfo } from '../../../../../../../player/EventLeaderboards/RaceTable/StillInRaceUserInfo';
import { useAssignResultsState } from '../../../../../Common/AssignResults/Context/AssignResults.context';

export const StillInRaceTable = () => {
  const { horseRaceEliminatedResults } = useAssignResultsState();

  return horseRaceEliminatedResults.false ? (
    <div className="stillInRace">
      <div className="headline-container">
        <h2 className="headline">
          <span>STILL IN THE RACE</span>
        </h2>
      </div>

      <Grid container={true} spacing={0}>
        {horseRaceEliminatedResults.false.map(result => (
          <Grid
            className="grid-item"
            item={true}
            xs={4}
            key={`still-in-race-${result.enrollmentId}`}
          >
            <StillInRaceUserInfo result={result} />
          </Grid>
        ))}
      </Grid>
    </div>
  ) : (
    <></>
  );
};
